import React from 'react';
import './StagePill.css';

const STAGES = [
  { key: 'discovery',   label: 'Discovery' },
  { key: 'evaluation',  label: 'Evaluation' },
  { key: 'bid_prep',    label: 'Bid Prep' },
  { key: 'submitted',   label: 'Submitted' },
  { key: 'won',         label: 'Won' },
];

const TERMINAL = {
  lost:      { label: 'Lost',      cls: 'stage-lost' },
  dropped:   { label: 'Dropped',   cls: 'stage-dropped' },
  canceled:  { label: 'Canceled',  cls: 'stage-dropped' },
  cancelled: { label: 'Cancelled', cls: 'stage-dropped' },
  no_go:     { label: 'No-Go',     cls: 'stage-dropped' },
};

function statusToStage(status) {
  if (!status) return null;
  const s = status.toLowerCase();
  if (s === 'discovered') return 'discovery';
  if (s === 'evaluating') return 'evaluation';
  if (s === 'participating') return 'bid_prep';
  if (s === 'submitted') return 'submitted';
  if (s === 'won') return 'won';
  return null;
}

function StagePill({ status }) {
  if (!status) return null;

  const terminal = TERMINAL[status.toLowerCase()];
  if (terminal) {
    return (
      <span className={`stage-pill ${terminal.cls}`}>
        <span className="stage-pill-label">{terminal.label}</span>
      </span>
    );
  }

  const stage = statusToStage(status);
  const stageIdx = STAGES.findIndex(s => s.key === stage);
  const current = stageIdx >= 0 ? STAGES[stageIdx] : null;

  if (!current) {
    return <span className="stage-pill stage-default"><span className="stage-pill-label">{status}</span></span>;
  }

  return (
    <span className={`stage-pill stage-${current.key}`}>
      <span className="stage-pill-label">{current.label}</span>
      <span className="stage-pill-dots" aria-hidden="true">
        {STAGES.map((s, i) => (
          <span key={s.key} className={`stage-dot ${i <= stageIdx ? 'filled' : ''}`} />
        ))}
      </span>
    </span>
  );
}

export default StagePill;
